import React, {useEffect, useState, useRef} from 'react';
import {useFormContext, useFieldArray, useWatch} from 'react-hook-form';
import {companyPropTypes, companyDefaultProps} from './panelProps';
import CustomFormBlock from '../../../pieces/inputs/formBlock';
import * as allConstants from '../../../constants/allConstants';
import Grid from '@mui/material/Grid';
import {Box, Card, CardContent, List, Typography, ListItem, FormControl} from '@mui/material';
import {useCompanyPageStyles} from '../companyPageStyles';
import {globalUseClasses} from '../../../styles/globalClasses';
import {inputTypes} from '../../../pieces/inputs/formInput';
import Utils from '../../../utils/utils';
import base_url from '../../../baseUrls';
import {NotAllowedToEditSection} from './notAllowedToEditSection';
import {AddRowButton, DeleteEquipmentRowButton, DeleteRowButton, variants} from '../../../pieces/addDeleteEquipmentRowButtons';
import { AutoCompleteComponent} from '@syncfusion/ej2-react-dropdowns';
import { DataManager, Query, UrlAdaptor } from '@syncfusion/ej2-data';
//import {FloatingLabel} from '../../../pieces/inputs/customInputComponent';
//import {useAutocompleteOptions} from '../../../hooks/useAutompleteOptions';
import ApiUtils from '../../../utils/apiUtils';
import './companySettings.css'
import { DAYS_OF_WEEK } from '../../../constants/options/calendarOptions';
import { INSPECTION_LIMIT_TYPES, JOB_TYPES } from '../../../constants/options/jobTypes';
import {COMPANY_ELEMENTS, companyRules} from '../../../permissions/companyAccessControl';
import {NewPermissionGate} from '../../../permissions/permissionGate';

import Spacer from '../../../pieces/spacer';

export const CompanyInspectionInfo = (props)=> {
  const [init] = useState(true);
  const [isEditable, setIsEditable] = useState(false);
  const classes = {...useCompanyPageStyles(), ...globalUseClasses()};
  const COMPANY_FIELDS = allConstants.COMPANY_FIELDS;

  //let authToken = useRef(null);
  const formMethods = useFormContext();

  const getCompanyData = ()=> {
    const initialData = props.tabProps?.companyData || {};
    return {...initialData, ...formMethods.getValues()};
  };
  const companyData = getCompanyData();

  console.log('company data user');
  console.log(props.user);
  console.log(props);


  //console.log(companyData.inspectionLimits);

  const getDefaultValue = (field, parent = null) => {
    if (parent) {
      return companyData?.[parent]?.[field];
    }
    return companyData?.[field];
  };

  useEffect ( () => {
    setIsEditable(NewPermissionGate({
      user: props.user,
      elementPermissions: companyRules[COMPANY_ELEMENTS.editInspInfo],
    }));

  },[props.user]);

  const commonFieldProps = {
    fullWidth: true,
    maxWidth: '100%',
    isEditable: isEditable,
  };

  const InspLimitCollectionName = COMPANY_FIELDS.INSPECTION_LIMITS.api_name;

  const InspLimitRow = {
   [COMPANY_FIELDS.LIMIT_TYPES.api_name]: [],
   [COMPANY_FIELDS.JOB_TYPES.api_name]: [],
   [COMPANY_FIELDS.ALLOWED_DAYS.api_name]: [],
   [COMPANY_FIELDS.PER_DAY.api_name]: 0,
   [COMPANY_FIELDS.PER_WEEK.api_name]: 0,
  };

  const {fields, append} = useFieldArray({
    control: formMethods.control,
    name: InspLimitCollectionName,
  });

  //console.log('fields');
  //console.log(fields);


  const InspLimitSubformDefaultProps = (index, fieldName) => ({
    defaultValue: '' , //`${InspLimitCollectionName}[${index}].${fieldName}`,
    isEditable: true,
    nested: true,
    fullWidth: true,
    width: '100%',
    parent: `${InspLimitCollectionName}[${index}]`
  });

  //console.log('insp limit subform');
  //console.log(InspLimitSubformDefaultProps);


  const deleteInspLimitRow = (index) => {
    try {
      const inspLimitList = [...formMethods.getValues()?.[allConstants.COMPANY_FIELDS.INSPECTION_LIMITS.api_name]];
      inspLimitList.splice(index, 1);
      formMethods.setValue(allConstants.COMPANY_FIELDS.INSPECTION_LIMITS.api_name, inspLimitList);
    } catch(e){

    }
  };

  return (
    <>
      <Grid container maxWidth={'100%'} spacing={3}>
        <NotAllowedToEditSection show={props.tabProps.notAllowedToEdit}/> 
        <Grid item sm={12} flex={1}>
          <Card className={classes.card_block} sx={{height: '100%'}}>
            <CardContent className={classes.half_width}>
              <Box display={'flex'} justifyContent={'space-between'}>
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  renderLabel={false}
                  labelLeft={true}
                  field={COMPANY_FIELDS.CITY_INSPECTION}
                  inputType={inputTypes.checkbox}
                  disabled={!isEditable}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.CITY_INSPECTION.api_name)}
                />
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  renderLabel={false}
                  labelLeft={true}
                  field={COMPANY_FIELDS.INSPECTION_AUTO_HOLD}
                  inputType={inputTypes.checkbox}
                  disabled={!isEditable}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.INSPECTION_AUTO_HOLD.api_name)}
                />
              </Box>  
            </CardContent>
          </Card>
        </Grid>
        <Grid item sm={12} flex={1}  >
          <Card className={classes.card_block}>
            <CardContent>
              <Box>
                <Typography className={classes.eq_name}>{COMPANY_FIELDS.INSPECTION_LIMITS.label}</Typography>
              </Box>
              <form>
                <List>
                  {fields.map((item, index) => (
                    <ListItem key={item.id} sx={{
                      display: 'grid',
                      paddingTop: '0',
                      paddingBottom: '0',
                      gridTemplateColumns: '140px 1fr 1fr 70px 70px 70px',
                      gap: '8px',
                      alignItems: 'flex-start'
                    }}>
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...InspLimitSubformDefaultProps(index, COMPANY_FIELDS.LIMIT_TYPES.api_name)}
                        field={COMPANY_FIELDS.LIMIT_TYPES}
                        inputType={inputTypes.multiSelect}
                        options={Utils.getOptions(INSPECTION_LIMIT_TYPES)}
                        disabled={!isEditable}
                        defaultValue={item.limitTypes}
                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...InspLimitSubformDefaultProps(index, COMPANY_FIELDS.JOB_TYPES.api_name)}
                        field={{...COMPANY_FIELDS.JOB_TYPES, ...{required: false}}}
                        inputType={inputTypes.multiSelect}
                        options={Utils.getOptions(JOB_TYPES)}
                        disabled={!isEditable}
                        defaultValue={item.jobTypes}
                        //defaultValue={getDefaultValue(COMPANY_FIELDS.ALLOWED_DAYS.api_name, COMPANY_FIELDS.LADDER_LIMIT.api_name)}
                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...InspLimitSubformDefaultProps(index, COMPANY_FIELDS.ALLOWED_DAYS.api_name)}
                        field={COMPANY_FIELDS.ALLOWED_DAYS}
                        inputType={inputTypes.multiSelect}
                        options={Utils.getOptions(DAYS_OF_WEEK)}
                        disabled={!isEditable}
                        defaultValue={item.allowedDays}
                        //defaultValue={getDefaultValue(COMPANY_FIELDS.ALLOWED_DAYS.api_name, COMPANY_FIELDS.LADDER_LIMIT.api_name)}
                      />
                      <CustomFormBlock
                          {...props.inputDefaultProps}
                          {...commonFieldProps}
                          {...InspLimitSubformDefaultProps(index)}
                          field={COMPANY_FIELDS.PER_DAY}
                          isEditable={isEditable}
                          //defaultValue={getDefaultValue(COMPANY_FIELDS.PER_DAY.api_name, COMPANY_FIELDS.LADDER_LIMIT.api_name)}s
                      />
                      <CustomFormBlock
                          {...props.inputDefaultProps}
                          {...commonFieldProps}
                          {...InspLimitSubformDefaultProps(index)}
                          field={COMPANY_FIELDS.PER_WEEK}
                          isEditable={isEditable}
                          //defaultValue={getDefaultValue(COMPANY_FIELDS.PER_WEEK.api_name, COMPANY_FIELDS.LADDER_LIMIT.api_name)}
                      />
                      {!props.inputDefaultProps.viewMode && isEditable  && <DeleteEquipmentRowButton eqName={'inspLimit'}
                        extraStyles={{alignSelf: 'baseline',
                          top: '8px',
                          position: 'relative',
                          padding: '0'
                        }}
                        deleteAction={() => deleteInspLimitRow(index)}
                      />}
                    </ListItem>)
                  )}
                </List>
                {!props.inputDefaultProps.viewMode && isEditable &&
                <AddRowButton eqName={'inspLimit'} variant={variants.textWithIcon}
                  addAction={() => {
                    append({...InspLimitRow});
                  }}
                />}
              </form>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

CompanyInspectionInfo.propTypes = companyPropTypes;
CompanyInspectionInfo.defaultProps = companyDefaultProps;
